// extracted by mini-css-extract-plugin
export var articles = "article-card-clean-module--articles--d6e32";
export var category = "article-card-clean-module--category--4cf96";
export var darkGradient = "article-card-clean-module--dark-gradient--691b9";
export var darkStyle = "article-card-clean-module--dark-style--7580e";
export var deskArticlesGrid = "article-card-clean-module--desk-articles-grid--8595e";
export var deskContent = "article-card-clean-module--desk-content--3a139";
export var featured = "article-card-clean-module--featured--29ab5";
export var footer = "article-card-clean-module--footer--5545b";
export var footerButton = "article-card-clean-module--footer-button--c33fd";
export var footerDivider = "article-card-clean-module--footer-divider--ad03e";
export var gatsbyImageWrapper = "article-card-clean-module--gatsby-image-wrapper--6567c";
export var inner = "article-card-clean-module--inner--a0b7d";
export var outer = "article-card-clean-module--outer--fcd4e";
export var readMoreText = "article-card-clean-module--read-more-text--d39de";
export var wideStyle = "article-card-clean-module--wide-style--1bd4f";
export var wrapper = "article-card-clean-module--wrapper--ec493";